import React from "react";
import { observer } from "mobx-react";
import { withStyles } from "@material-ui/styles";
import { toJS } from "mobx";
import { withAlert } from "react-alert";
import Layout from "../../components/Layout";
import store from "../../stores/smsStore";
import '../../styles/sms.css';
import {
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableCell,
  TableRow,
  Button,
  Grid,
  TextField,
  Fade,
} from "@material-ui/core";
import Moment from "moment";
import Paper from "@material-ui/core/Paper";
import smslist from "../../data/smslist.json";
import Chart from "react-apexcharts";
import sms from "../../stores/smsStore";
const today = Moment().format("YYYY-MM-DD");
const styles = (theme) => ({
  tableContainer: {
    marginTop: 20,
  },
  button: {
    margin: 0,
  },
  cardDiv: {
    maxWidth: 500,
  },
  cardBtn: {
    width: "100%",
  },
});
String.prototype.replaceAll = function (org, dest) {
  return this.split(org).join(dest);
};
const View = observer(
  class SMS extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
        startDt: Moment(toJS(store.startDt)).format("YYYY-MM-DD"),
        endDt: Moment(toJS(store.endDt)).format("YYYY-MM-DD"),
      };
    }

    handleClick = async () => {
      if (this.state) {
        if (this.state.startDt && this.state.endDt) {
        } else {
          this.props.alert.show("입력필드를 확인해주세요.");
          return;
        }
        var startDt = Moment(this.state.startDt);
        var endDt = Moment(this.state.endDt);
        var diff = endDt.diff(startDt, "days");
        if (diff >= 0) {
          sms.getSmsList(
            startDt._i.replaceAll("-", ""),
            endDt._i.replaceAll("-", "")
          );
        } else {
          this.props.alert.show("시작날짜가 종료날짜보다 큽니다.");
        }
      } else {
        this.props.alert.show("입력필드를 확인해주세요.");
      }
    };
    handleChange = async (e) => {
      await this.setState({
        [e.target.name]: e.target.value,
      });
    };

    render() {
      const { classes } = this.props;
      // const list = toJS(store.list).sort(this.compStringReverse);

      const list = toJS(store.list).sort(function (a, b) {
        return a.locname < b.locname ? -1 : a.locname > b.locname ? 1 : 0;
      });

      const chartList = toJS(store.list).sort(
        (a, b) => parseInt(b.count) - parseInt(a.count)
      );

      const options = {
        title: {
          text: "SMS 기관수 : " + chartList.length,
          align: "left",
          margin: 10,
          offsetX: 0,
          offsetY: 0,
          floating: false,
          style: {
            fontSize: "14px",
            fontWeight: "bold",
            fontFamily: undefined,
            color: "#263238",
          },
        },
        chart: {
          id: "인포테크 SMS 사용량",
          height: "100%",
        },
        xaxis: {
          categories: chartList.map((item) => item.locname),
        },
        plotOptions: {
          bar: {
            horizontal: true,
          },
        },
      };
      const series = [{ data: chartList.map((item) => item.count) }];
      const blocking = toJS(store.blocking);

      return (
        <Layout>
          <Grid className={classes.tableContainer}>
            {/* <Grid container spacing={3}> */}
              
              
            {/* <Grid item xs={2}>
                <TextField
                  name="startDt"
                  format="YYYYMMDD"
                  onChange={this.handleChange}
                  type="date"
                  defaultValue={this.state.startDt}
                />
              </Grid>
              <Grid item xs={2}>
                <TextField
                  name="endDt"
                  onChange={this.handleChange}
                  type="date"
                  defaultValue={this.state.endDt}
                />
              </Grid>
              <Grid item xs={2}>
                <Button
                  variant="contained"
                  color="primary"
                  size="large"
                  onClick={this.handleClick}
                  disabled={blocking}
                >
                  검색하기
                </Button>
              </Grid> */}
              <div class='fsSms'>
              <div class='firstSms'>
                <TextField
                  name="startDt"
                  format="YYYYMMDD"
                  onChange={this.handleChange}
                  type="date"
                  defaultValue={this.state.startDt}
                  />
              </div>
              <div class='secondSms'>
                <TextField
                  name="endDt"
                  onChange={this.handleChange}
                  type="date"
                  defaultValue={this.state.endDt}
                  />
              </div>
              </div>
              <div class='lastSms'>
                <Button
                  variant="contained"
                  color="primary"
                  size="large"
                  onClick={this.handleClick}
                  disabled={blocking}
                  >
                  검색하기
                </Button>
              </div>

            {/* </Grid> */}
          </Grid>
          <Fade in={list.length > 0}>
            <Grid container spacing={3}>
              <div class='smsSearch'>
                <TableContainer
                  component={Paper}
                  className={classes.tableContainer}
                  >
                  <Table aria-label="simple table">
                    <TableHead>
                      <TableRow>
                        <TableCell align="center">기관</TableCell>
                        <TableCell align="center">횟수</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {list.map((item) => (
                        <TableRow key={item.locname}>
                          <TableCell style={{ padding: 0 }} align="center">
                            {item.locname}
                          </TableCell>
                          <TableCell style={{ padding: 0 }} align="center">
                            {item.count}
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </div>
              <div class='smsTotal'>
                <Paper className={classes.tableContainer}>
                  <Chart options={options} series={series} type="bar" />
                </Paper>
              </div>
              {/* <Grid item xs={6}>
                <TableContainer
                  component={Paper}
                  className={classes.tableContainer}
                >
                  <Table aria-label="simple table">
                    <TableHead>
                      <TableRow>
                        <TableCell align="center">기관</TableCell>
                        <TableCell align="center">횟수</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {list.map((item) => (
                        <TableRow key={item.locname}>
                          <TableCell style={{ padding: 0 }} align="center">
                            {item.locname}
                          </TableCell>
                          <TableCell style={{ padding: 0 }} align="center">
                            {item.count}
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Grid>
              <Grid item xs={6}>
                <Paper className={classes.tableContainer}>
                  <Chart options={options} series={series} type="bar" />
                </Paper>
              </Grid> */}

            </Grid>
          </Fade>
        </Layout>
      );
    }
  }
);

const alertView = withAlert()(View);
export default withStyles(styles)(alertView);
